import _ from 'lodash';

export function extractErrorCode(error: any) {
  if (error.code) {
    return error.code;
  }

  return _.get(error, 'graphQLErrors[0].extensions.exception.code', 'Unknown');
}
